module.exports = __webpack_public_path__ + "img/brand--korber.27f8cea7.svg";